import PopupCreatePriceQuoteGI from './PopupCreatePriceQuoteGI';

export default PopupCreatePriceQuoteGI;
